import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IOrderCompleteModel } from '@apps-common/types/management/order'

export const completeOrder = async (model: IOrderCompleteModel): Promise<boolean> =>
  axios.post(`/management/order/completeorder`, model).then((res) => res?.data?.data)

type Props = {
  model: IOrderCompleteModel
}

export const useManagementCompleteOrder = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['completeOrder'],
    mutationFn: ({ model }: Props) => completeOrder(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated order.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update order, please try again.')
      }
    },
    throwOnError: false
  })
